const getCognitoToken = async (config) => {
  const request = {
    method: 'POST', 
    headers: config.headers, 
    body: config.body
  };
  const response = await fetch(config.cognitoUrl, request);
  const res = await response.json();
  if(res && res.access_token)
    return res.access_token;

  throw new Error('Failed to get cognito response');
};

export default getCognitoToken;
